/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderInstallmentsEditDialog extends Common.GridEditorDialog<OrderInstallmentsRow> {
        protected getFormKey() { return OrderInstallmentsForm.formKey; }
        protected getLocalTextPrefix() { return OrderInstallmentsRow.localTextPrefix; }

        protected form = new OrderInstallmentsForm(this.idPrefix);
       // protected form: OrderProductsForm;
        public stateIds: number;

        public OrderStatus: number;
        constructor() {
            super();
           
/*
            this.form.ProductId.change(e => {
                var vproductId = this.form.ProductId.value;

                if (Q.isEmptyOrNull(vproductId)) {
                    this.setProductDetails({});
                }
                else {

                    try {
                        Orders.OrderProductsService.GetProductDetails({
                            ProductId: parseInt(vproductId)
                            //      
                        }, response => {
                            this.form.ProductId.value = this.form.ProductId.value;
                            this.form.HasBooks.value = response.HasBooks;
                            this.form.HasPendrive.value = response.HasPendrives;
                            this.form.HasCourier.value = response.HasCourier;
                            this.form.IsLive.value = response.IsLive;
                            this.form.DownloadUrl1.value = response.DownloadUrl1;
                            this.form.DownloadUrl2.value = response.DownloadUrl2;
                            this.form.EOpens.value = response.EOpens.toString();
                            this.form.EWatchTime.value = response.EWatchTime.toString();
                            this.form.InvoiceCompanyId.value = response.InvoiceCompanyId.toString();
                            this.form.EValidity.value = response.EValidity.toString();
                            this.form.EValidityType.value = response.EValidityType.toString();
                            this.form.ValidTill.value = response.ValidTill;
                            this.form.TotalAllowedDuration.value = response.TotalAllowedDuration;
                            this.form.EAccessStatus.value = response.EAccessStatus.toString();
                        });
                    } catch (e) { }
                }
            });*/
            //this.form.Quantity.changeSelect2(e => {
            //    var productId = this.form.ProductId.value.toString();
            //    var ProductSpecificationId = this.form.ProductSpecificationId.value;
            //    var stateIds = this.stateIds;
            //    debugger;
            //    if (this.isNew() == false) {
            //        Q.confirm('Are you sure you want to change Quantity,This will update Order and its Invoice?', () => {

                      
            //        });
            //    }
               



            //});
            //this.form.DiscountAmt.changeSelect2(e => {
            //    Q.confirm('Are you sure you want to change Discount,This will update Order and its Invoice?', () => {

            //    });


            //});
        }

        //private seEntityDetails(totalTaxRate: number) {
            
        //    if (this.form.Quantity.value == null) {
        //        this.form.Quantity.value = 1;
        //    }
        //  //  this.form.TaxAmount.value = this.form.Amount.value * totalTaxRate / 100;

        //    //  this.form.Amount.value = this.form.Quantity.value * this.form.Cost.value;

        //}
        //private setProductDetails(details: Products.ProductsRow) {
        //    if (this.form.Quantity.value == null) {
        //        this.form.Quantity.value = 1;
        //    }
        //    /*this.form.Cost.value = details.Cost;*/
        //    if (details.EOpens != null)
        //        this.form.EOpens.value = details.EOpens.toString();
        //    if (details.EWatchTime != null)
        //        this.form.EWatchTime.value = details.EWatchTime.toString();
        //    if (details.EValidityType != null)
        //        this.form.EValidityType.value = details.EValidityType.toString();
        //    if (details.EValidity != null)
        //        this.form.EValidity.value = details.EValidity.toString();
        //    if (details.EAccessStatus != null)
        //        this.form.EAccessStatus.value = details.EAccessStatus.toString();
        //    if (details.ValidTill != null)
        //        this.form.ValidTill.value = details.ValidTill;
        //    if (details.HasBooks != null)
        //        this.form.HasBooks.value = details.HasBooks;
        //    if (details.HasPenDrive != null)
        //        this.form.HasPendrive.value = details.HasPenDrive;
        //    if (details.HasCourier != null)
        //        this.form.HasCourier.value = details.HasCourier;
        //    if (details.IsLive != null)
        //        this.form.IsLive.value = details.IsLive;
        //    if (details.DownloadUrl1 != null)
        //        this.form.DownloadUrl1.value = details.DownloadUrl1;
        //    if (details.DownloadUrl2 != null)
        //        this.form.DownloadUrl2.value = details.DownloadUrl2;
        //    if (details.TotalAllowedDuration != null)
        //        this.form.TotalAllowedDuration.value = details.TotalAllowedDuration;
        //    /*this.form.Amount.value = this.form.Quantity.value * this.form.Cost.value;*/

        //}
        //private setProductSpecificationDetails(details: Products.ProductSpecificationsRow) {
        //    debugger;
        //    if (details.Eopens != null)
        //        this.form.EOpens.value = details.Eopens.toString();
        //    if (details.EWatchtime != null)
        //        this.form.EWatchTime.value = details.EWatchtime.toString();
        //    if (details.EValidityType != null)
        //        this.form.EValidityType.value = details.EValidityType.toString();
        //    if (details.EValidity != null)
        //        this.form.EValidity.value = details.EValidity.toString();
        //    if (details.ValidTill != null)
        //        this.form.ValidTill.value = details.ValidTill;
        //    if (details.HasBooks != null)
        //        this.form.HasBooks.value = details.HasBooks;
        //    if (details.HasPendrive != null)
        //        this.form.HasPendrive.value = details.HasPendrive;         
        //    if (details.IsLive != null)
        //        this.form.IsLive.value = details.IsLive;
        //    if (details.AllowedDevices != null)
        //        this.form.AllowedDevice.value = details.AllowedDevices;
        //        //this.form.Cost.value = details.ProductCost ;
        //        //this.form.Amount.value = this.form.Cost.value * this.form.Quantity.value;  

        //}
        //private setTaxRateDetails(detailsTaxRate: Masters.TaxRatesRow) {

        //    debugger;
        //    this.form.TaxAmount.value = this.form.Amount.value * detailsTaxRate.Rate / 100;

        //}        

        //loadEntity(entity: OrderProductsRow) {
        //    super.loadEntity(entity);

           
           
        //    if (this.form.SerialKey.value != "") {
        //        Serenity.EditorUtils.setReadonly(this.form.SerialKey.element, true);
        //    }
        //}

    }
}